// AWS S3 工具函数

/**
 * S3 Bucket 基础 URL（从环境变量读取）
 */
const S3_BUCKET_URL = import.meta.env.VITE_S3_BUCKET_URL;

/**
 * 将 S3 文件键转换为完整的 URL
 * @param fileKey - S3 文件键（相对路径）或已经是完整 URL
 * @returns 完整的 S3 URL，如果 fileKey 为空则返回空字符串
 *
 * @example
 * getS3Url('users/2/avatars/profile/xxx.jpeg')
 * // 返回: 'https://prepwise-prod.s3.amazonaws.com/users/2/avatars/profile/xxx.jpeg'
 *
 * getS3Url('https://example.com/image.jpg')
 * // 返回: 'https://example.com/image.jpg' (已经是完整 URL，直接返回)
 *
 * getS3Url(null)
 * // 返回: ''
 */
export function getS3Url(fileKey: string | null | undefined): string {
  if (!fileKey) return '';

  // 如果已经是完整 URL，直接返回
  if (fileKey.startsWith('http://') || fileKey.startsWith('https://')) {
    return fileKey;
  }

  // 拼接完整的 S3 URL
  return `${S3_BUCKET_URL}/${fileKey}`;
}
